// Customer-side translations. English is the default; a customer's choice is remembered in this browser.
// Deliberately tiny (no library): t('buy.city'), t('plan.save', { pct: 20 }). A missing Chinese entry falls
// back to English, and a missing key shows the key, so a gap is visible instead of blank.
// Admin pages stay English and do not use this.
import { ref } from 'vue';
import en from './en';
import zhCN from './zh-CN';

const MESSAGES = { en, 'zh-CN': zhCN };
export const LANGUAGES = [
    { code: 'en', label: 'EN', name: 'English' },
    { code: 'zh-CN', label: '中文', name: '简体中文' },
];
const KEY = 'lang';

const stored = () => {
    try { const v = localStorage.getItem(KEY); return MESSAGES[v] ? v : 'en'; } catch (e) { return 'en'; }
};

export const locale = ref(stored());

const lookup = (dict, key) => key.split('.').reduce((o, k) => (o != null && o[k] !== undefined ? o[k] : undefined), dict);

export function t(key, params) {
    // reading locale.value here makes every template that calls t() re-render when the language changes
    let s = lookup(MESSAGES[locale.value], key);
    if (s === undefined) s = lookup(en, key);
    if (s === undefined) return key;
    if (params) s = String(s).replace(/\{(\w+)\}/g, (m, k) => (params[k] !== undefined && params[k] !== null ? params[k] : m));
    return s;
}

export function applyToDocument() {
    document.documentElement.lang = locale.value;
    document.body.classList.toggle('lang-zh', locale.value === 'zh-CN');
}

export function setLocale(code) {
    if (!MESSAGES[code]) return;
    locale.value = code;
    try { localStorage.setItem(KEY, code); } catch (e) { /* the choice just will not stick */ }
    applyToDocument();
}

export default {
    install(app) {
        app.config.globalProperties.$t = t;
        applyToDocument();
    },
};
